<span class="experience__period-range {{ styleType }}">
  {{ duration | durationPeriod: durationType }}
</span>
@if (withDateRange) {
  <span class="experience__date-range">
    &nbsp;—
    @if (duration?.durationYear) {
      <span>
        {{
          duration.durationYear
            | pluralize: ('GENERAL.YEAR_SHORT' | translate) : ('GENERAL.YEARS_SHORT' | translate)
        }}
      </span>
    }
    @if (duration?.durationMonth) {
      <span>
        {{
          duration.durationMonth
            | pluralize: ('GENERAL.MONTH_SHORT' | translate) : ('GENERAL.MONTHS_SHORT' | translate)
        }}
      </span>
    }
  </span>
}
